import React from 'react'
import Header from '../Layout/Header'
import IntegrationBanner from './IntegrationBanner'
import Chrome from './Chrome'
import Testimonials from '../Home/HomeSections/Testimonials'
import Lorem from '../Home/HomeSections/Lorem'
import Footer from '../Layout/Footer'

export default function IntegrationHome() {
  return (
    <div>
        <Header/>
        <IntegrationBanner/>
        <Chrome className='a'/>
        <Testimonials/>
        <Lorem/>
        <Footer />
    </div>
  )
}
